// extracted by mini-css-extract-plugin
export default {"baseStyles":"HW_upv"};